export default () => ({
    state: Alpine.$persist('active').using(sessionStorage).as('alert'),

    content: {
        ['x-show']() {
            return this.state == 'active'
        },
    },

    close: {
        ['@click']() {
            this.state = 'closed'
        },
    },
})
